export const OTP_HEADERS = {
  challenge: "X-OTP-Challenge",
  code: "X-OTP-Challenge-Code",
} as const;
